export default __webpack_public_path__ + "static/media/SZN1.b34b75af.gif";